import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fatchLogout } from '../../store/auth-actions';
import { initTexts } from "../../store/translate-actions";
import iconUser from '../../assests/header/icon-user.png'
import UserProfile from "../lms-shared/UI/UserProfile";
import classes from "./UserInfo.module.css";
import { onKeyDown } from "../../service";

const UserInfo = ({ userInfo, openEdit }) => {
    const user = useSelector(state => state.auth.user);
    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const dispatch = useDispatch()

    function changeLang(lang) {
        try {
            if (localStorage.getItem('LANG') !== lang) {
                localStorage.setItem('LANG', lang)
                dispatch(initTexts);
                window.location.reload();
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div className={classes.UserInfo}>
            <UserProfile width="74px"
                image={user.profileImage ?
                    `${user.profileImage}` :
                    iconUser}
            >
                <div className={classes.EditImg} onClick={openEdit} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, openEdit)}></div>
            </UserProfile>
            <div className={classes.UserName}>{user.firstName} {user.lastName}</div>
            <div className={classes.UserSchools}>
                {userInfo && userInfo.map((s, i) =>
                    <div className={classes.UserSchool} key={i}>{texts.school} {s}</div>
                )}
            </div>
            {/* <div className={classes.AddRemoveSchool} onClick={() => { }}>{texts.addOrRemoveSchool}</div> */}
            <div className={classes.UserLang}>
                <div className={`${classes.LangBtn} ${localStorage.getItem('LANG') === 'he' ? classes.CurrentLang : ''}`} onClick={() => changeLang('he')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeLang('he'))}>ע</div>
                <div className={`${classes.LangBtn} ${localStorage.getItem('LANG') === 'ar' ? classes.CurrentLang : ''}`} onClick={() => changeLang('ar')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeLang('ar'))}>ع</div>
                <div className={`${classes.LangBtn} ${localStorage.getItem('LANG') === 'en' ? classes.CurrentLang : ''}`} onClick={() => changeLang('en')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeLang('en'))}>E</div>
            </div>
            <div className={classes.Logout} onClick={() => fatchLogout(homeUrl)}  tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => fatchLogout(homeUrl))}>{texts.logout}</div>
        </div >
    )
}
export default UserInfo